// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".avatar-tag-image[data-v-3024acca]{min-width:150px}.avatar-tag-image.--dyot[data-v-3024acca]{padding:0 19px}", ""]);
// Exports
module.exports = exports;
